import React, { useState, useEffect } from 'react'
import { Row, Col } from 'reactstrap';
import { TextField } from '@material-ui/core';
import BuscarButton from '../../../components/buttons/BuscarButton';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from 'react-loaders'

//Redux
import { connect } from 'react-redux';

//API Calls
const { apiGetUserAuth } = require('../../../utils/APIs/APISResume')

const mapStateToProps = state => ({
    usuarioActivo: state
})

const axios = require('axios');

let BodyMail = (props) => {
    const [searchEmail, setSearchEmail] = useState('');
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));

    const getUserDataByEmail = async () => {
        setLoading(true)
        const body = {
            email: searchEmail,
            token: userData.token
        }
        const userDataReq = await apiGetUserAuth(body);
        if (userDataReq.status === 200) {
            setUser(userDataReq.data.data)
            props.toastSuccess('usuario encontrado')
        }
        else if(userDataReq.status === 404) {
            setUser({})
            props.toastError('Usuario no encontrado')
        }
        else {
            setUser({})
            props.toastError('Hubo un error')
        }
        setLoading(false);
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='10' md='10' xs="10">
                        <TextField
                            required
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='correo'
                            margin="normal"
                            onChange={(e) => { setSearchEmail(e.target.value) }}
                        />
                    </Col>
                    <Col lg='2' md='2' xs="2">
                        <BuscarButton
                            disabled={!searchEmail.includes('@')}
                            onClick={() => { getUserDataByEmail() }} />
                    </Col>
                </Row>
                <div className='user-by-email'>
                    {loading ? <Loader type="line-scale-party" /> : Object.keys(user).length > 0 ? <Row className='user-by-email'>
                        <Col lg='6' md='12' xs="12">
                            <TextField
                                required
                                key={`key_mail`}
                                id={`input_mail`}
                                fullWidth
                                label='Correo'
                                defaultValue={user.email}
                                margin="normal"
                            />
                        </Col>
                        <Col lg='6' md='12' xs="12">
                            <TextField
                                required
                                key={`key_mail`}
                                id={`input_mail`}
                                fullWidth
                                label='Cédula'
                                defaultValue={user.username}
                                margin="normal"
                                disabled
                            />
                        </Col>
                    </Row> : <p>No se encontro el usuario</p>}
                </div>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyMail);